export default __webpack_public_path__ + "static/media/ux.f23cef12.svg";